import { render, staticRenderFns } from "./UnderConstruction.vue?vue&type=template&id=22337921&"
var script = {}
import style0 from "./UnderConstruction.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports